module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "asec1",
      "title": "Teach a Girl to Fish"
    }
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#sec1"
    }
  }, [_vm._v("TEACH A GIRL TO FISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctr2"
  }, [_vm._v("{AS TOLD TO THE EDITOR}")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("STRONG BITE")]), _vm._v(". A frenzied whirring of the reel. A whiskered aquatic creature splashed through the surface of the river and thrashed about, dangling at the end of a bent rod. It was a climactic moment for my cousins and me as we sat on the edge of the river side by side on a warm sunny day, fishing poles in hand, eyes and mouths wide open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was about 10, and camping by the river with my stepdad’s big family was an every-weekend affair. During the day, we fished, swam, and boated through waters that sparkled like tinsel. On the boat, Grandpa assembled a crate with baited hooks, which he released onto the water to troll for catfish. He reeled in enough fish to feed a hungry mob. I watched with horrified fascination as he gutted the horned pout, cut through its skin around the head and the shoulder blade, and pulled the skin off with pliers. For the grand finale, Grandpa sprinkled salt on the fish, prompting the headless, gutless, and skinless body to leap into the air and dance a postmortem jig.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was not born in this land of plenty. I was no stranger, however, to rivers and fish. I was born in the Philippines and was transplanted to the United States when my mother married my stepfather, who was in the Marines. Although I was only five when we moved, I would never forget the life we left behind in the third world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m begging you,” Grandmother had said to my mother in Tagalog. “Leave your daughter here with me.” Her voice had choked with desperation when she found out about our impending immigration to the United States.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "132",
      "src": "images/f0017-01.jpg",
      "width": "116"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "aut",
    attrs: {
      "id": "asec1-1"
    }
  }, [_c('b', [_c('span', {
    staticClass: "bro"
  }, [_vm._v("CRISTINA QUACKENBUSH")]), _vm._v(" was born in Malabon in Manila, Philippines. At the age of five, she moved with her mother to Evansville, Indiana, where she was raised near her step-grandmother’s farm. Her mother’s cooking sustained her throughout her childhood, while her grandmother taught her a farm-to-table lifestyle. As an adult, Cristina held various positions at restaurants managing both kitchens and the front of the house with prominent New Orleans chefs. In 2012, with the encouragement of Chef Adolfo Garcia, Cristina began her journey toward opening the doors to Philippine cuisine in the Crescent City.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("But how could Mom do that? Asking her to leave me—her only child—was unthinkable. It would have meant depriving me of a chance for a better life. The place my grandmother referred to as “here” was in the slums of Malabon in Metro Manila.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Malabon lies along the lowlands of Manila Bay, near the mouths of three vast rivers. Once dotted by ponds swarming with fish, the area was then crammed with shacks swarming with hungry squatters. Often, sewage water pooled on open surfaces, discharging a putrid smell. Clusters of tiny, box-type huts sprouted along muddy, narrow alleys on the tidal terrain, and the lack of proper drainage guaranteed flooding as often as rainfall on our tropical archipelago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But sunshine filled the place each morning when I saw Grandmother. As soon as I got up from the wicker mat that was our bed, there she was. Love beamed from her every smile, every word, and every touch. She took care of me like I was her very own, spoiled me beyond her meager means, treated me like a princess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a family of 10—Grandma, great-uncles, cousins, Mom, and me—we crouched around the coffee table in our teetering shanty during mealtimes. Our single-room dwelling reeked of fish. We didn’t have a refrigerator, just as we didn’t have plumbing, a dining table and chairs, beds, or the space to house basic furniture. We had survived mostly on meals of fish and rice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the river in Indiana, my cousins and I skittered back to camp at dusk. Twigs crunched under our feet while the unmistakable whiff of fish grilling on charcoal wafted to our noses. Dinner that night was "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("celestial. Cooked fish was the star of the supper for everyone except my mother. She preferred a dish called kinilaw, a vinegar-cured raw fish. Unlike the rest of us, Mom chowed down with gusto on rice and catfish kinilaw, which was marinated in vinegar, red onion, cucumber, and tomatoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom’s zest for kinilaw didn’t arouse my appetite for the dish. The thought of eating uncooked fish made me squirm with disgust. Like most people in the United States at that time, I had developed a phobia of ingesting anything raw. Moreover, how could I stomach raw catfish after I had witnessed it being caught and butchered? To me, eating uncooked fish was barbaric, unhygienic, and a precursor to illness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom reminded me that this was a dish we used to have in the Philippines. I was too little to remember, but according to her, it was a common dish back home because preserving food in vinegar had been more affordable and feasible for us than owning a fridge. Vinegar also gave the fish flavor and texture. If salt could make a fish dance, vinegar could make a dish sing.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Vinegar gave the fish flavor and texture. If salt could make a fish dance, vinegar could make a dish sing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After dinner, we sat around a campfire, roasting marshmallows under a dome of glittering stars. The prospect of sleeping in the wilderness excited me. I retired to the tent and lay down on the floor, just as we had done in the Philippines. Intoxicated by the day’s happenings and lulled by frogs croaking, leaves rustling, and water swishing, I dozed off, cradled by Mother Nature.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "1",
      "src": "images/line1.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("My apprehensions about eating kinilaw dissipated only years later. I discovered that vinegar, an acid, is liquid fire. Like heat, it cooks the fish and kills pathogens. When it comes to adding flavor and enhancing the presentation of the dish, the possibilities are limitless. Who would have known that I would one day open the only Filipino restaurant in New Orleans, and that my version of kinilaw would be a star of the menu?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Latin Americans, kinilaw is like ceviche. To Hawaiians, it’s known as poke. To Guamanians, it’s kelaguen. To me, a chef born in the Philippines and raised in the Midwest, kinilaw is about keeping an open mind and taking chances. If I had let my prejudices hold me back, God knows what I would have missed. It would probably have been as unthinkable as turning down my opportunity to relish life in the US of A.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A wise man once said, “Give a man a fish, and you feed him for a day; teach a man to fish, and you feed him for a lifetime.” I say, “Teach a girl to fish, and she will feed you for a lifetime.” "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/com.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "11",
      "src": "images/com.jpg",
      "width": "12"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a414c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter001sec1.vue
// module id = 90
// module chunks = 0